module.exports = __webpack_public_path__ + "img/DE01549.dea80be0.png";